import React from 'react';
import { useTranslation } from 'next-i18next';
import { PlayArrowRounded, PauseRounded } from '@mui/icons-material';
import BaseControlButton, { IControlButtonProps } from '../control-base';

const PlayControlButton: React.FC<IControlButtonProps> = (props) => {
  const {
    active,
    disabled = false,
    className = '',
    onClick = () => {},
  } = props;

  const { t: tButtons } = useTranslation('buttons');

  const icon = active ? (
    <PauseRounded fontSize="inherit" />
  ) : (
    <PlayArrowRounded fontSize="inherit" />
  );
  const text = active ? tButtons('pause') : tButtons('play');

  return (
    <BaseControlButton
      className={className}
      icon={icon}
      text={text}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default PlayControlButton;
